<template>
    <div>
        <PageLoader :isPage="true" :isLoaded="false" />
    </div>
</template>
<script>
    import { reactive, toRefs, onMounted } from "vue";
    import { useRouter } from "vue-router";
    import { useStore } from "vuex";

    import { Links } from "@/helpers/links";
    import { appData } from "@/helpers/global";
    import { Web } from "@/helpers/web";

    import PageLoader from "@/components/PageLoader.vue";
    import { StorePerson } from "@/store/constants";

    export default {
        name: "DefaultView",
        components: {
            PageLoader,
        },
        setup() {
            const router = useRouter();
            const store = useStore();

            const e = reactive({
                detect() {
                    if (store.getters[StorePerson.isLogin]) {
                        router.push(Links.Url(Links.Home));
                    }
                    else {
                        Web.Redirect(Links.Url(Links.Login));
                    }
                }
            });
            onMounted(() => {
                try {
                    setTimeout(function () { e.detect(); }, 100);
                } catch (ex) { console.log(ex.message); }
            });
            return { ...toRefs(e) };
        },
    };
</script>
